import { Component, Input, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ProgressStep } from '../../interfaces/progress-step.interface';
import { ApiService } from '../../services/api.service'
import { AccountType } from '../../interfaces/api/AccountType'

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: ['./progress-bar.component.scss'],
  standalone: true,
  imports: [CommonModule, TranslateModule]
})
export class ProgressBarComponent implements OnInit{
  @Input() steps: ProgressStep[] = [];
  @Input() currentStep: number = 1;
  @Input() orientation: 'horizontal' | 'vertical' = 'horizontal';
  @Input() disabled: boolean = false;
  @Input() showDescription: boolean = true;
  @Input() noAbsoluteText: boolean = false

    style: 'ctop' | 'we' = 'we'

    constructor(private api: ApiService) {
    }

    ngOnInit() {
      if(AccountType.isCtop(this.api.userInfo.getValue().accountType)){
          this.style = 'ctop'
      }
    }

    get showHorizontalSteps(): boolean {
    return this.orientation === 'horizontal';
  }

  get showVerticalTimeline(): boolean {
    return this.orientation === 'vertical';
  }

  getStepStatus(index: number): 'complete' | 'active' | 'pending' {
    if (this.steps[index]?.status) {
      return this.steps[index].status!;
    }

    if (index + 1 < this.currentStep) {
      return 'complete';
    } else if (index + 1 === this.currentStep) {
      return 'active';
    }
    return 'pending';
  }

  isStepComplete(index: number): boolean {
    return this.getStepStatus(index) === 'complete';
  }

  isStepActive(index: number): boolean {
    return this.getStepStatus(index) === 'active';
  }

  isStepPending(index: number): boolean {
    return this.getStepStatus(index) === 'pending';
  }

  getStepClasses(index: number): string {
    return `group relative flex flex-col pb-8 pl-7 last:pb-0 
      ${this.isStepComplete(index) ? 'complete' : ''} 
      ${this.isStepActive(index) ? 'active' : ''} 
      ${this.disabled ? 'opacity-50' : ''}`;
  }

  getDiamondClasses(index: number): string {
    const baseClasses = 'absolute h-3 w-3 -left-[3px] top-2 transform-gpu rotate-[25deg] transition-transform border';
    
    if (this.isStepComplete(index)) {
      return `${baseClasses} bg-primary-default border-primary-default`;
    }
    if (this.isStepActive(index)) {
      return `${baseClasses} bg-white border-primary-default`;
    }
    return `${baseClasses} bg-white border-divider-divider`;
  }

  getLineClasses(): string {
    return 'absolute bottom-0 left-[calc(0.25rem-0.5px)] top-0 w-px bg-divider-divider group-first:top-3';
  }

  getLabelClasses(index: number): string {
    if (this.isStepComplete(index)) {
      return 'text-text-terciary';
    }
    if (this.isStepActive(index)) {
      return 'text-text-primary';
    }
    return 'text-text-disabled';
  }
}
